import FadeTransition from "@/styles/animation/FadeTransition";
import style from "@/styles/pages/Error/Error.module.css";

interface errorProps {
  title: string;
  content: any;
}

export default function ErrorTemplate({ title, content }: errorProps) {

  const handleExit = () => {
    window.location.href = 'https://www.meridiancu.ca/';
  };

  return (
    <FadeTransition>
      <main aria-labelledby="main-content">
        <div className="flex flex-col max-xs:px-3 items-center max-md:mt-20">
          <div className={style.errHeading}>
            <div>
              <h1>{title}</h1>
              <p className="mt-3">{content}</p>
            </div>
          </div>
          <div className="mb-5">
            <button className="primary mt-5 w-full  h-11 px-6" onClick={handleExit}>
              Exit Application
            </button>
          </div>
        </div>
      </main>
    </FadeTransition>
  );
}
